export const BillingPlanCodes = Object.freeze({
  Standard2025Q2: 'standard_2025q2',
  Premium2025Q2: 'premium_2025q2',
});
